module.exports = __webpack_public_path__ + "static/media/O65-2500.5edad0d5.jpg";